import React, { useState } from "react";
import { Navigate } from "react-router-dom";
import {
  APPLICANT_APPLICATION_ROUTE,
  APPLICANT_WORKSPACE_ROUTE,
  routeAfterCentralLogin,
  useAccess,
} from "../auth/AccessProvider";
import AccessRouteState from "../auth/AccessRouteState";
import CentralDashboardShell from "./CentralDashboardShell";
import SystemRouterLanding from "./SystemRouterLanding";
import "../styles/platformAccess.css";
import "./ApplicantWorkspace.css";

const NAV_ITEMS = [
  { id: "systems", label: "Your systems", icon: "systems" },
];

export default function ApplicantWorkspace() {
  const {
    accessContext,
    activeTenant,
    loading,
    signOutUser,
    user,
  } = useAccess();
  const [signOutPending, setSignOutPending] = useState(false);

  if (loading) return <AccessRouteState title="Opening your workspace…" />;
  if (!user) return <Navigate to="/login" replace />;

  const destination = routeAfterCentralLogin(accessContext || {});
  if (
    destination !== APPLICANT_APPLICATION_ROUTE &&
    destination !== APPLICANT_WORKSPACE_ROUTE
  ) {
    return <Navigate to={destination} replace />;
  }

  const handleSignOut = async () => {
    setSignOutPending(true);
    try {
      await signOutUser();
    } finally {
      setSignOutPending(false);
    }
  };

  return (
    <div className="applicant-workspace">
      <CentralDashboardShell
        user={accessContext?.user || user}
        organisation={activeTenant?.displayName}
        branding={activeTenant?.branding}
        navItems={NAV_ITEMS}
        activeSection="systems"
        onSectionChange={() => {}}
        onSignOut={handleSignOut}
        navigationDisabled={signOutPending}
        signOutPending={signOutPending}
        sidebarNote="The programme stays closed until your application is approved."
      >
        <SystemRouterLanding
          user={accessContext?.user || user}
          tenant={activeTenant}
          systems={activeTenant?.systems || []}
          emptyTitle="No programme is open yet."
          emptyMessage="You are signed in. The programme stays closed until your application is approved."
        />
      </CentralDashboardShell>
    </div>
  );
}
